"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtils_1 = require("../lib/ArrayUtils");
var Constants = require("./Constants");
var MemberType_1 = require("./MemberType");
var TTRMode_1 = require("./TTRMode");
var PhaseType_1 = require("./PhaseType");
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var IndexationBasis_1 = require("./IndexationBasis");
var AnnuityPurchasePriceTable_1 = require("./AnnuityPurchasePriceTable");
var TTR_SEARCH_TOLERANCE = 25;
var TTR_MAX_SEARCH_DEPTH = 10;
var TTR_DRAWINGS_MAX_SEARCH_DEPTH = 25;
var TTR_DRAWINGS_SEARCH_TOLERANCE = 10;
var DRAWINGS_SEARCH_TOLERANCE = 20;
var DRAWINGS_MAX_SEARCH_DEPTH = 30;
var _1960_7_1 = new Date(1960, 6, 1, 12, 0, 0).getTime();
var _1961_7_1 = new Date(1961, 6, 1, 12, 0, 0).getTime();
var _1962_7_1 = new Date(1962, 6, 1, 12, 0, 0).getTime();
var _1963_7_1 = new Date(1963, 6, 1, 12, 0, 0).getTime();
var _1964_7_1 = new Date(1964, 6, 1, 12, 0, 0).getTime();
var _2014_1_1 = new Date(2014, 0, 1, 12, 0, 0).getTime();
var _2015_1_1 = new Date(2015, 0, 1, 12, 0, 0).getTime();
var Person = (function () {
    function Person() {
        this._dateBirth = null;
        this._age = 0;
        this._startAge = 0;
        this._sex = null;
        this._retirementAge = 0;
        this._preservationAge = 0;
        this._expectedAgeAtDeath = 0;
        this._lifeExpectancyAtRetirement = 0;
        this._sunSuperSurvival50Percent = 0;
        this._sunSuperSurvival10Percent = 0;
        this._isHomeOwner = false;
        this._isMarried = false;
        this._accountType = null;
        this._memberType = null;
        this._includeTtr = false;
        this._TTRMode = TTRMode_1.TTRMode.TaxOptimisation;
        this._TTRUserSpecifiedDrawings = null;
        this._phase = null;
        this._retiredThisYear = false;
        this._ttrContributions = 0;
        this._ttrDrawings = 0;
        this._ttrIncomeReduction = 0;
        this._ttrTaxBenefit = 0;
        this._ttrPostContributionNetSalary = 0;
        this._ttrProblemCanNotTopUpSalary = false;
        this._preTaxMemberContributions = null;
        this._postTaxMemberContributions = null;
        this._coreContributionsPostTax = false;
        this._coContributions = 0;
        this._lumpSumWithdrawalAtRetirement = 0;
        this._indexedLumpSumWithdrawalAtRetirement = null;
        this._annualFullTimeSalary = null;
        this._midYearSalary = 0;
        this._targetIncome = null;
        this._FinancialAssets = [];
        this._IncomeOnFinancialAssets = [];
        this._NonFinancialAssets = null;
        this._IncomeOnNonFinancialAssets = null;
        this._IncomeWithNoBackingAssets = [];
        this._IncomeWithNoBackingAssets_CeaseAge = [];
        this._OtherIncome = null;
        this._PersonalAssets = null;
        this._concessionalContributionThreshold = null;
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold = null;
        this._lowIncomeEarnersGovernmentContributionMaximum = null;
        this._highIncomeEarningThreshold = null;
        this._annualFullTimeSalaryHistory = [];
        this._annualFullTimeMidYearSalaryHistory = [];
        this._workDaysPerWeek = [];
        this._targetIncomeHistory = [];
        this._OtherIncomeHistory = [];
        this._individualsTargetIncomeHistory = [];
        this._incomeTaxHistory = [];
        this._preTaxMemberContributionHistory = [];
        this._postTaxMemberContributionHistory = [];
        this._lumpSumMemberContributions = [];
        this._DownsizerContributions = [];
        this._rollOver = [];
        this._ttrContributionsHistory = [];
        this._ttrDrawingsHistory = [];
        this._ttrIncomeReductionHistory = [];
        this._ttrTaxBenefitHistory = [];
        this._ttrPostContributionNetSalaryHistory = [];
        this._ttrProblemCanNotTopUpSalaryHistory = [];
        this._retirementDrawingsHistory = [];
        this._agePensionHistory = [];
        this._indexedPensionHistory = [];
        this._arrayCounter = 0;
        this._deflatedSalary = [];
        ;
        this._deflatedPreTaxMemberContribution = [];
        ;
        this._deflatedPostTaxMemberContribution = [];
        ;
        this._deflatedNetSalary = [];
        ;
        this._deflatedOtherIncome = [];
        ;
        this._deflatedTargetIncome = [];
        ;
        this._deflatedAgePension = [];
        ;
        this._deflatedIndexedPension = [];
        ;
        this._IsARetirementIncomeProduct = false;
        this._RetirementIncomeProduct_ElectionBasedOnAssetsToConvert = false;
        this._RetirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert = false;
        this._debugMode = false;
    }
    Person.prototype.initialise = function (p, ageNow, sex, salary, retirementAge, homeOwner, married, preTaxMemberContributions, postTaxMemberContributions, targetIncome, NonFinancialAssets, IncomeOnNonFinancialAssets, NonFinancialAssetsGrowthRate, PersonalAssets, partTimeWorkDaysPerWeek, partTimeWorkYearsDuration, partTimeWorkFromAge, oneOffContribution, oneOffContributionMadeAtAge, includeTTR, TTRModeTaxOptimisation, TTRUserSpecifiedDrawings, lumpSumWithdrawalAtRetirement, thisAccountType, thisMemberType, wageIndexation, priceIndexation, arraySize, coreContributionsPostTax, rollOver, rollOverMadeAtAge, initialExternalPension, futureYearsCurrentEmployment, IsARetirementIncomeProduct, RetirementIncomeProductPurchaseAge, RetirementIncomeProductIncomeStartAge, retirementIncomeProduct_ElectionBasedOnAssetsToConvert, retirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert, retirementIncomeProductPurchaseProportion, retirementIncomeProduct_PurchaseAssetBalance, retirementIncomeProduct_AimAnnualIncome, retirementIncomeProductIndexationRate, retirementIncomeProduct_UseDefaultIncomePer100KPurchase, retirementIncomeProductIncomePer100KPurchase, discountWithPriceInflationInRetirement, TTR_CurrentWorkLoad, TTR_ProposedWorkLoad, TTRMode_UserSpecifiesDrawingAmount, debugMode) {
        if (debugMode === void 0) { debugMode = false; }
        var partTimeDaysPerWeek;
        var partTimeDuration;
        var partTimeCommencementAge;
        var lumpSumContribution;
        var lumpSumContributionMadeAtAge;
        this._debugMode = debugMode;
        this._annualFullTimeSalary = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._targetIncome = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._NonFinancialAssetsGrowthRate = new IndexationBasis_1.IndexationBasis();
        this._NonFinancialAssets = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._IncomeOnNonFinancialAssets = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._OtherIncome = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._PersonalAssets = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._concessionalContributionThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._indexedLumpSumWithdrawalAtRetirement = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._preTaxMemberContributions = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._postTaxMemberContributions = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._lowIncomeEarnersGovernmentContributionMaximum = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._highIncomeEarningThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._TTRUserSpecifiedDrawings = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._age = ageNow;
        this._startAge = ageNow;
        this._sex = sex;
        this._retirementAge = retirementAge;
        this._isHomeOwner = homeOwner;
        this._isMarried = married;
        this._accountType = thisAccountType;
        this._memberType = thisMemberType;
        this._coreContributionsPostTax = coreContributionsPostTax;
        if (futureYearsCurrentEmployment === 0) {
            this._ageCeaseCurrentEmployment = 0;
        }
        else {
            this._ageCeaseCurrentEmployment = ageNow + futureYearsCurrentEmployment;
        }
        this._NonFinancialAssetsGrowthRate.initialise([NonFinancialAssetsGrowthRate]);
        this._NonFinancialAssets.initialise(NonFinancialAssets, this._NonFinancialAssetsGrowthRate);
        this._IncomeOnNonFinancialAssets.initialise(IncomeOnNonFinancialAssets, this._NonFinancialAssetsGrowthRate);
        this._annualFullTimeSalary.initialise(salary, wageIndexation);
        if (this._memberType === MemberType_1.MemberType.AUSTRALIAN_SUPER) {
            this._PersonalAssets.initialise(PersonalAssets, wageIndexation);
        }
        else {
            this._PersonalAssets.initialise(PersonalAssets, priceIndexation);
        }
        this._lumpSumWithdrawalAtRetirement = lumpSumWithdrawalAtRetirement;
        partTimeDaysPerWeek = partTimeWorkDaysPerWeek;
        partTimeDuration = partTimeWorkYearsDuration;
        partTimeCommencementAge = partTimeWorkFromAge;
        lumpSumContribution = oneOffContribution;
        lumpSumContributionMadeAtAge = oneOffContributionMadeAtAge;
        this._includeTtr = includeTTR;
        if (this._includeTtr) {
            if (TTRModeTaxOptimisation) {
                this._TTRMode = TTRMode_1.TTRMode.TaxOptimisation;
            }
            else if (TTRMode_UserSpecifiesDrawingAmount) {
                this._TTRMode = TTRMode_1.TTRMode.DrawingsOnly_UserSpecifyAmount;
            }
            else {
                this._TTRMode = TTRMode_1.TTRMode.DrawingsOnly_TopUpReducedSalary;
            }
        }
        else {
            this._TTRMode = TTRMode_1.TTRMode.TaxOptimisation;
        }
        if (this._TTRMode === TTRMode_1.TTRMode.DrawingsOnly_TopUpReducedSalary) {
            partTimeDaysPerWeek = 5 * TTR_ProposedWorkLoad / TTR_CurrentWorkLoad;
            partTimeDuration = this._retirementAge - this._age;
            partTimeCommencementAge = this._age;
        }
        this._TTRUserSpecifiedDrawings.initialise(TTRUserSpecifiedDrawings, wageIndexation);
        this._concessionalContributionThreshold.initialise(p.getParamNumber("ConcessionalContributionThreshold"), wageIndexation);
        this._indexedLumpSumWithdrawalAtRetirement.initialise(lumpSumWithdrawalAtRetirement, wageIndexation);
        this._preTaxMemberContributions.initialise(preTaxMemberContributions, wageIndexation);
        this._postTaxMemberContributions.initialise(postTaxMemberContributions, wageIndexation);
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold.initialise(p.getParamNumber("LowIncomeEarnersGovernmentContributionIncomeThreshold"), wageIndexation);
        this._lowIncomeEarnersGovernmentContributionMaximum.initialise(p.getParamNumber("LowIncomeEarnersGovernmentContributionMaximum"), wageIndexation);
        this._highIncomeEarningThreshold.initialise(p.getParamNumber("HighIncomeEarningThreshold"), wageIndexation);
        var monthsToAdd = -6 - this._age * 12;
        var calculateDate = p.getParamObject("CalculationDate");
        this._dateBirth = calculateDate.plus(monthsToAdd / 12);
        this._preservationAge = this.getPreservationAge();
        this._midYearSalary = this._annualFullTimeSalary.value * (1 + this._annualFullTimeSalary.getIndexationInYear(1) / 2);
        this._expectedAgeAtDeath = p.getParamObject("AbsLifeTable").lifeExpectancy(this._age, this._sex);
        this._lifeExpectancyAtRetirement = p.getParamObject("AlternateLifeTable").lifeExpectancy(this._retirementAge, this._sex);
        this._sunSuperSurvival50Percent = p.getParamObject("SunSuper_50").lifeExpectancy(this._retirementAge, this._sex);
        this._sunSuperSurvival10Percent = p.getParamObject("SunSuper_10").lifeExpectancy(this._retirementAge, this._sex);
        this._annualFullTimeSalaryHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._annualFullTimeMidYearSalaryHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._workDaysPerWeek = ArrayUtils_1.InitialiseArray(arraySize);
        this._targetIncomeHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._OtherIncomeHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._retirementIncomeProductIncomeHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._superannuationDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._agePensionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._indexedPensionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrContributionsHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrDrawingsHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrIncomeReductionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrTaxBenefitHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrPostContributionNetSalaryHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._ttrProblemCanNotTopUpSalaryHistory = Array.from({ length: arraySize }, function () { return false; });
        this._retirementDrawingsHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._preTaxMemberContributionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._postTaxMemberContributionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._lumpSumMemberContributions = ArrayUtils_1.InitialiseArray(arraySize);
        this._DownsizerContributions = ArrayUtils_1.InitialiseArray(arraySize);
        this._rollOver = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedSalary = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedPreTaxMemberContribution = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedPostTaxMemberContribution = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedNetSalary = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedOtherIncome = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedTargetIncome = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedAgePension = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedIndexedPension = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedSuperannuationDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedRetirementIncomeProductIncomeHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._individualsTargetIncomeHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._incomeTaxHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this.setWorkDaysPerWeek(partTimeDaysPerWeek, partTimeDuration, partTimeCommencementAge, this._age, this._retirementAge);
        this.setLumpSumContribution(lumpSumContribution, lumpSumContributionMadeAtAge);
        this.setRollOver(rollOver, rollOverMadeAtAge);
        this.updatePhase();
        this._arrayCounter = 0;
        if (this._phase === PhaseType_1.PhaseType.RETIRED) {
            this._preTaxMemberContributions.resetValues(0);
            this._postTaxMemberContributions.resetValues(0);
            this._preTaxMemberContributionHistory[this._arrayCounter] = 0;
            this._postTaxMemberContributionHistory[this._arrayCounter] = 0;
        }
        else if (this._annualFullTimeSalary.value === 0) {
            this._preTaxMemberContributionHistory[this._arrayCounter] = this._preTaxMemberContributions.value;
            this._postTaxMemberContributionHistory[this._arrayCounter] = this._postTaxMemberContributions.value;
        }
        else {
            this._preTaxMemberContributions.resetValues(this._preTaxMemberContributions.value * this._midYearSalary / this._annualFullTimeSalary.value);
            this._postTaxMemberContributions.resetValues(this._postTaxMemberContributions.value * this._midYearSalary / this._annualFullTimeSalary.value);
            this._preTaxMemberContributionHistory[this._arrayCounter] = this._preTaxMemberContributions.value;
            this._postTaxMemberContributionHistory[this._arrayCounter] = this._postTaxMemberContributions.value;
        }
        this._discountWithPriceInflationInRetirement = discountWithPriceInflationInRetirement;
        if (this._phase === PhaseType_1.PhaseType.RETIRED &&
            this._discountWithPriceInflationInRetirement) {
            this._targetIncome.initialise(targetIncome, priceIndexation);
        }
        else {
            this._targetIncome.initialise(targetIncome, wageIndexation);
        }
        this._annualFullTimeSalaryHistory[this._arrayCounter] = this._annualFullTimeSalary.value;
        this._annualFullTimeMidYearSalaryHistory[this._arrayCounter] = this._midYearSalary;
        this._targetIncomeHistory[this._arrayCounter] = this._targetIncome.value;
        this._OtherIncomeHistory[this._arrayCounter] = this._OtherIncome.value;
        this._retirementDrawingsHistory[this._arrayCounter] = 0;
        this._IsARetirementIncomeProduct = IsARetirementIncomeProduct;
        this._RetirementIncomeProduct_ElectionBasedOnAssetsToConvert = retirementIncomeProduct_ElectionBasedOnAssetsToConvert;
        this._RetirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert = retirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert;
        this._RetirementIncomeProduct_AgeOfPurchase = RetirementIncomeProductPurchaseAge;
        this._RetirementIncomeProduct_AgeIncomeStart = RetirementIncomeProductIncomeStartAge;
        this._RetirementIncomeProduct_PurchaseProportion = retirementIncomeProductPurchaseProportion;
        this._RetirementIncomeProduct_PurchaseAssetBalance = retirementIncomeProduct_PurchaseAssetBalance;
        this._RetirementIncomeProduct_AimAnnualIncome = retirementIncomeProduct_AimAnnualIncome;
        var RIP_InflationFactor = Math.pow((1 + wageIndexation.getIndexationRate(1)), (retirementAge - ageNow)) *
            Math.pow((1 + priceIndexation.getIndexationRate(1)), (this._RetirementIncomeProduct_AgeOfPurchase - retirementAge));
        this._RetirementIncomeProduct_PurchaseAssetBalance_FutureDollars = this._RetirementIncomeProduct_PurchaseAssetBalance * RIP_InflationFactor;
        this._RetirementIncomeProduct_AimAnnualIncome_FutureDollars = this._RetirementIncomeProduct_AimAnnualIncome * RIP_InflationFactor;
        this._RetirementIncomeProduct_UseDefaultIncomePer100KPurchase = retirementIncomeProduct_UseDefaultIncomePer100KPurchase;
        this._RetirementIncomeProduct_IncomePer100KPurchase = retirementIncomeProductIncomePer100KPurchase;
        this._RetirementIncomeProduct_IndexationBasis = new IndexationBasis_1.IndexationBasis();
        this._RetirementIncomeProduct_Income = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._RetirementIncomeProduct_IndexationBasis.initialise(retirementIncomeProductIndexationRate);
        this._RetirementIncomeProduct_Income.initialise(0, this._RetirementIncomeProduct_IndexationBasis);
        this._TTR_CurrentWorkLoad = TTR_CurrentWorkLoad;
        this._TTR_ProposedWorkLoad = TTR_ProposedWorkLoad;
    };
    Person.prototype.initialiseCoreAccumulationContributionRate = function (memberContributionRate) {
        if (this._coreContributionsPostTax) {
            this._postTaxMemberContributions.resetValues(this._postTaxMemberContributions.value + memberContributionRate * this._midYearSalary);
            this._postTaxMemberContributionHistory[this._arrayCounter] = this._postTaxMemberContributionHistory[this._arrayCounter] +
                this._midYearSalary * memberContributionRate *
                    this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
        }
        else {
            this._preTaxMemberContributions.resetValues(this._preTaxMemberContributions.value + memberContributionRate * this._midYearSalary);
            this._preTaxMemberContributionHistory[this._arrayCounter] = this._preTaxMemberContributionHistory[this._arrayCounter] +
                this._midYearSalary * memberContributionRate *
                    this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
        }
    };
    Person.prototype.SizeTheFinancialAssetsArray = function (ArraySize) {
        if (ArraySize > 0) {
            ArraySize++;
        }
        this._FinancialAssets = Array.from({ length: ArraySize }, function () { return null; });
        this._IncomeOnFinancialAssets = Array.from({ length: ArraySize }, function () { return null; });
    };
    Person.prototype.InitialiseFinancialAssets = function (AssetValue, Income, GrowthRate, counter) {
        this._FinancialAssets[counter] = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._IncomeOnFinancialAssets[counter] = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._FinancialAssets[counter].initialise(AssetValue, GrowthRate);
        this._IncomeOnFinancialAssets[counter].initialise(Income, GrowthRate);
    };
    Person.prototype.SizeTheIncomeWithNoBackingAssetsArray = function (ArraySize) {
        if (ArraySize > 0) {
            ArraySize++;
        }
        this._IncomeWithNoBackingAssets = Array.from({ length: ArraySize }, function () { return null; });
        this._IncomeWithNoBackingAssets_CeaseAge = Array.from({ length: ArraySize }, function () { return null; });
    };
    Person.prototype.InitialiseIncomeWithNoBackingAssets = function (IncomeLevel, CeaseAge, priceinflation, wageinflation, counter) {
        this._IncomeWithNoBackingAssets[counter] = new IndexedDollarParameter_1.IndexedDollarParameter();
        if (this._memberType === MemberType_1.MemberType.AUSTRALIAN_SUPER) {
            this._IncomeWithNoBackingAssets[counter].initialise(IncomeLevel, wageinflation);
        }
        else {
            this._IncomeWithNoBackingAssets[counter].initialise(IncomeLevel, priceinflation);
        }
        this._IncomeWithNoBackingAssets_CeaseAge[counter] = CeaseAge;
    };
    Person.prototype.setInitialOtherIncome = function () {
        var TotalOtherIncome;
        TotalOtherIncome = this._IncomeOnNonFinancialAssets.value;
        for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
            TotalOtherIncome += this._IncomeOnFinancialAssets[counter].value;
        }
        for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
            TotalOtherIncome += this._IncomeWithNoBackingAssets[counter].value;
        }
        this._OtherIncomeHistory[this._arrayCounter] = TotalOtherIncome;
        this._OtherIncome.resetValues(TotalOtherIncome);
    };
    Person.prototype.setLengthOfFirstPeriod = function (age_PartYear) {
        this._LengthOfPeriodInFirstProjectionPeriod = 1 - age_PartYear;
    };
    Person.prototype.RetirementIncomeProduct_SetDefaultIncomePer100KPurchase_WithReversion = function (p, PartnerAge, PartnerSex) {
        var AnnuityTable;
        var AnnuityTableString;
        var annuityTableObj = null;
        AnnuityTableString = "CSC_Annuity_Reversion_" + this._sex + '_' + this._age + "_Partner_" + PartnerSex;
        annuityTableObj = p.getParamObject(AnnuityTableString);
        if (annuityTableObj !== null) {
            AnnuityTable = new AnnuityPurchasePriceTable_1.AnnuityPurchasePriceTable();
            AnnuityTable.initialise(annuityTableObj.startAge, annuityTableObj.data);
            this._RetirementIncomeProduct_IncomePer100KPurchase = AnnuityTable.getAnnuityPurchasePrice(PartnerAge);
        }
        if (this.debugMode) {
            console.log("ENGINE 671 ==> annuityTableObj... tried to get ", AnnuityTableString, annuityTableObj);
        }
    };
    Person.prototype.RetirementIncomeProduct_SetDefaultIncomePer100KPurchase_Single = function (p) {
        var AnnuityTable;
        var AnnuityTableString;
        var annuityTableObj = null;
        AnnuityTableString = "CSC_Annuity_Single_" + this._sex;
        annuityTableObj = p.getParamObject(AnnuityTableString);
        if (annuityTableObj !== null) {
            AnnuityTable = new AnnuityPurchasePriceTable_1.AnnuityPurchasePriceTable();
            AnnuityTable.initialise(annuityTableObj.startAge, annuityTableObj.data);
            this._RetirementIncomeProduct_IncomePer100KPurchase = AnnuityTable.getAnnuityPurchasePrice(this._age);
        }
    };
    Person.prototype.setRetirementIncomeProductIncome = function (initialIncomeLevel) {
        this._RetirementIncomeProduct_Income.resetValues(initialIncomeLevel);
        this._retirementIncomeProductIncomeHistory[this._arrayCounter] = this._RetirementIncomeProduct_Income.value;
    };
    Person.prototype.setRetirementIncomeProductIncomeBasedOnIncomeAim = function (MaximumAnnuityGivenBalance) {
        var AssetsForPurchasePrice = 100000;
        this._RetirementIncomeProduct_Income.resetValues(Math.min(this._RetirementIncomeProduct_AimAnnualIncome_FutureDollars, MaximumAnnuityGivenBalance));
        if (this._age === this._RetirementIncomeProduct_AgeIncomeStart) {
            this._retirementIncomeProductIncomeHistory[this._arrayCounter] = this._RetirementIncomeProduct_Income.value;
        }
        this._RetirementIncomeProduct_PurchaseAssetBalance = this._RetirementIncomeProduct_Income.value /
            this._RetirementIncomeProduct_IncomePer100KPurchase *
            AssetsForPurchasePrice;
    };
    Person.prototype.getPreservationAge = function () {
        if (this._dateBirth.before(_1960_7_1)) {
            return 55;
        }
        if (this._dateBirth.before(_1961_7_1)) {
            return 56;
        }
        if (this._dateBirth.before(_1962_7_1)) {
            return 57;
        }
        if (this._dateBirth.before(_1963_7_1)) {
            return 58;
        }
        if (this._dateBirth.before(_1964_7_1)) {
            return 59;
        }
        return 60;
    };
    Person.prototype.setWorkDaysPerWeek = function (partTimeDaysPerWeek, partTimeDuration, partTimeCommencementAge, age, retirementAge) {
        var partTimeYearsCount;
        var inPartTimePeriod;
        partTimeYearsCount = 0;
        inPartTimePeriod = false;
        for (var counter = 1; counter <= this._workDaysPerWeek.length; counter++) {
            if (age >= retirementAge) {
                this._workDaysPerWeek[counter - 1] = 0;
            }
            else if (((this._age + counter - 1 === partTimeCommencementAge) || inPartTimePeriod)) {
                if (partTimeYearsCount < partTimeDuration) {
                    inPartTimePeriod = true;
                }
                else {
                    inPartTimePeriod = false;
                }
                if (inPartTimePeriod) {
                    this._workDaysPerWeek[counter - 1] = partTimeDaysPerWeek;
                    partTimeYearsCount = partTimeYearsCount + 1;
                }
                else {
                    this._workDaysPerWeek[counter - 1] = Constants.FULL_TIME_DAYS_PER_WEEK;
                }
            }
            else {
                this._workDaysPerWeek[counter - 1] = Constants.FULL_TIME_DAYS_PER_WEEK;
            }
            age = age + 1;
        }
    };
    Person.prototype.setLumpSumContribution = function (lumpSumContribution, lumpSumContributionMadeAtAge) {
        for (var counter = 1; counter <= this._lumpSumMemberContributions.length; counter++) {
            if (this._startAge + counter - 1 === lumpSumContributionMadeAtAge) {
                this._lumpSumMemberContributions[counter - 1] = lumpSumContribution;
            }
            else {
                this._lumpSumMemberContributions[counter - 1] = 0;
            }
        }
    };
    Person.prototype.setDownsizerContribution = function (contribution, contributionMadeAtAge) {
        for (var counter = 1; counter <= this._DownsizerContributions.length; counter++) {
            if (this._startAge + counter - 1 == contributionMadeAtAge) {
                this._DownsizerContributions[counter - 1] = contribution;
            }
            else {
                this._DownsizerContributions[counter - 1] = 0;
            }
        }
    };
    Person.prototype.setRollOver = function (rollOver, rollOverMadeAtAge) {
        for (var counter = 0; counter < this._rollOver.length; counter++) {
            if (this._startAge + counter === rollOverMadeAtAge) {
                this._rollOver[counter] = rollOver;
            }
            else {
                this._rollOver[counter] = 0;
            }
        }
    };
    Person.prototype.annualUpdate = function (projectionRunAsAt, year) {
        var startThisProjectionYear;
        var indexationRate;
        this._age = this._age + 1;
        this._arrayCounter = this._arrayCounter + 1;
        startThisProjectionYear = projectionRunAsAt.plus(year - 1);
        this.updatePhase();
        if (this._phase === PhaseType_1.PhaseType.RETIRED) {
            this._annualFullTimeSalary.resetValues(0);
            this._midYearSalary = 0;
            this._ttrContributions = 0;
            this._ttrDrawings = 0;
            this._ttrContributionsHistory[this._arrayCounter] = 0;
            this._ttrDrawingsHistory[this._arrayCounter] = 0;
            this._preTaxMemberContributions.resetValues(0);
            this._postTaxMemberContributions.resetValues(0);
            this._indexedLumpSumWithdrawalAtRetirement.index(year);
            this._targetIncome.index(year);
            this._NonFinancialAssets.index(year);
            this._IncomeOnNonFinancialAssets.index(year);
            this._PersonalAssets.index(year);
            for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
                this._FinancialAssets[counter].index(year);
                this._IncomeOnFinancialAssets[counter].index(year);
            }
            for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
                this._IncomeWithNoBackingAssets[counter].index(year);
            }
        }
        else if ((this._arrayCounter === 1) &&
            ((this._memberType === MemberType_1.MemberType.ESSS_AssistMe) || (this._memberType === MemberType_1.MemberType.ESSS_AssistMe_DB))) {
            indexationRate = this._targetIncome.getIndexationInYear(this._arrayCounter);
            this._targetIncome.resetValues(this._targetIncome.value * Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
                indexationRate = this._FinancialAssets[counter].getIndexationInYear(this._arrayCounter);
                this._FinancialAssets[counter].resetValues(this._FinancialAssets[counter].value *
                    Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
                indexationRate = this._IncomeOnFinancialAssets[counter].getIndexationInYear(this._arrayCounter);
                this._IncomeOnFinancialAssets[counter].resetValues(this._IncomeOnFinancialAssets[counter].value *
                    Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            }
            for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
                indexationRate = this._IncomeWithNoBackingAssets[counter].getIndexationInYear(this._arrayCounter);
                this._IncomeWithNoBackingAssets[counter].resetValues(this._IncomeWithNoBackingAssets[counter].value *
                    Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            }
            indexationRate = this._NonFinancialAssets.getIndexationInYear(this._arrayCounter);
            this._NonFinancialAssets.resetValues(this._NonFinancialAssets.value *
                Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            indexationRate = this._IncomeOnNonFinancialAssets.getIndexationInYear(this._arrayCounter);
            this._IncomeOnNonFinancialAssets.resetValues(this._IncomeOnNonFinancialAssets.value *
                Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            indexationRate = this._PersonalAssets.getIndexationInYear(this._arrayCounter);
            this._PersonalAssets.resetValues(this._PersonalAssets.value *
                Math.pow(1 + indexationRate, this._LengthOfPeriodInFirstProjectionPeriod));
            indexationRate = this._annualFullTimeSalary.getIndexationInYear(this._arrayCounter);
            this._annualFullTimeSalary.resetValues(this._annualFullTimeSalary.value * Math.pow((1 + indexationRate), this._LengthOfPeriodInFirstProjectionPeriod));
            this._midYearSalary = this._annualFullTimeSalary.value * (1 + this._annualFullTimeSalary.getIndexationInYear(year) / 2);
            this._preTaxMemberContributions.resetValues(this._preTaxMemberContributions.value * Math.pow((1 + indexationRate), this._LengthOfPeriodInFirstProjectionPeriod));
            this._postTaxMemberContributions.resetValues(this._postTaxMemberContributions.value * Math.pow((1 + indexationRate), this._LengthOfPeriodInFirstProjectionPeriod));
            indexationRate = this._TTRUserSpecifiedDrawings.getIndexationInYear(this._arrayCounter);
            this._TTRUserSpecifiedDrawings.resetValues(this._TTRUserSpecifiedDrawings.value * Math.pow((1 + indexationRate), this._LengthOfPeriodInFirstProjectionPeriod));
            this._retirementDrawingsHistory[this._arrayCounter] = 0;
        }
        else {
            this._indexedLumpSumWithdrawalAtRetirement.index(year);
            this._targetIncome.index(year);
            this._NonFinancialAssets.index(year);
            this._IncomeOnNonFinancialAssets.index(year);
            this._PersonalAssets.index(year);
            for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
                this._FinancialAssets[counter].index(year);
                this._IncomeOnFinancialAssets[counter].index(year);
            }
            for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
                this._IncomeWithNoBackingAssets[counter].index(year);
            }
            this._annualFullTimeSalary.index(year);
            this._midYearSalary = this._annualFullTimeSalary.value * (1 + this._annualFullTimeSalary.getIndexationInYear(year) / 2);
            this._preTaxMemberContributions.index(year);
            this._postTaxMemberContributions.index(year);
            this._TTRUserSpecifiedDrawings.index(year);
            this._retirementDrawingsHistory[this._arrayCounter] = 0;
        }
        for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
            if (this._age == this._IncomeWithNoBackingAssets_CeaseAge[counter]) {
                this._IncomeWithNoBackingAssets[counter].resetValues(0);
            }
        }
        this._targetIncomeHistory[this._arrayCounter] = this._targetIncome.value;
        this._OtherIncomeHistory[this._arrayCounter] = this._IncomeOnNonFinancialAssets.value;
        for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
            this._OtherIncomeHistory[this._arrayCounter] += this._IncomeWithNoBackingAssets[counter].value;
        }
        for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
            this._OtherIncomeHistory[this._arrayCounter] += this._IncomeOnFinancialAssets[counter].value;
        }
        this._OtherIncome.resetValues(this._OtherIncomeHistory[this._arrayCounter]);
        this._annualFullTimeSalaryHistory[this._arrayCounter] = this._annualFullTimeSalary.value;
        this._annualFullTimeMidYearSalaryHistory[this._arrayCounter] = this._midYearSalary;
        if (this._annualFullTimeSalary.value === 0) {
            this._preTaxMemberContributionHistory[this._arrayCounter] = this._preTaxMemberContributions.value;
            this._postTaxMemberContributionHistory[this._arrayCounter] = this._postTaxMemberContributions.value;
        }
        else {
            this._preTaxMemberContributionHistory[this._arrayCounter] =
                this._preTaxMemberContributions.value * this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
            this._postTaxMemberContributionHistory[this._arrayCounter] =
                this._postTaxMemberContributions.value * this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
        }
        this._concessionalContributionThreshold.index(year);
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold.index(year);
        this._lowIncomeEarnersGovernmentContributionMaximum.index(year);
        this._highIncomeEarningThreshold.index(year);
        if (this._age < this._RetirementIncomeProduct_AgeIncomeStart) {
            this._retirementIncomeProductIncomeHistory[this._arrayCounter] = 0;
        }
        else if (this._age === this._RetirementIncomeProduct_AgeIncomeStart) {
            this._retirementIncomeProductIncomeHistory[this._arrayCounter] = this._RetirementIncomeProduct_Income.value;
        }
        else {
            this._RetirementIncomeProduct_Income.index(year);
            this._retirementIncomeProductIncomeHistory[this._arrayCounter] = this._RetirementIncomeProduct_Income.value;
        }
    };
    Person.prototype.updatePhase = function () {
        if (this._age === this._retirementAge) {
            this._phase = PhaseType_1.PhaseType.RETIRED;
            this._retiredThisYear = true;
        }
        else if (this._age > this._retirementAge) {
            this._phase = PhaseType_1.PhaseType.RETIRED;
            this._retiredThisYear = false;
        }
        else if (this._includeTtr &&
            this._age >= this._preservationAge &&
            (!(this._annualFullTimeSalary.value === 0) ||
                this._TTRMode == TTRMode_1.TTRMode.DrawingsOnly_UserSpecifyAmount ||
                this._TTRMode == TTRMode_1.TTRMode.DrawingsOnly_TopUpReducedSalary)) {
            this._phase = PhaseType_1.PhaseType.TTR;
            this._retiredThisYear = false;
        }
        else {
            this._phase = PhaseType_1.PhaseType.ACCUMULATION;
            this._retiredThisYear = false;
        }
    };
    Person.prototype.resetTargetIncomeIndexationBasis = function (indexationBasis) {
        this._targetIncome.resetIndexationBasis(indexationBasis);
    };
    Person.prototype.resetOtherIncomeIndexationBasis = function (indexationBasis) {
        for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
            this._IncomeWithNoBackingAssets[counter].resetIndexationBasis(indexationBasis);
        }
    };
    Person.prototype.drawingsRequiredToAttainTargetIncome = function (targetIncome, otherIncome, agePensionIncome, indexedPensionIncome, paygIncomeTaxBasis) {
        var superannuationDrawings;
        var drawingsTest;
        var taxAtTestDrawingLevel;
        var pensionRebateAtTestDrawingLevel;
        if (this._age >= 60) {
            superannuationDrawings = targetIncome
                - (agePensionIncome
                    + otherIncome
                    + indexedPensionIncome
                    - paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, agePensionIncome));
        }
        else {
            drawingsTest = targetIncome - agePensionIncome - otherIncome - indexedPensionIncome;
            taxAtTestDrawingLevel = paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, agePensionIncome + drawingsTest);
            pensionRebateAtTestDrawingLevel = drawingsTest * Constants.PENSION_REBATE_RATE;
            if (pensionRebateAtTestDrawingLevel >= taxAtTestDrawingLevel) {
                superannuationDrawings = drawingsTest;
            }
            else {
                superannuationDrawings = this.getRequiredDrawingsUnder60(targetIncome, otherIncome, agePensionIncome, indexedPensionIncome, paygIncomeTaxBasis, 0, this._targetIncome.value);
            }
        }
        return Math.max(superannuationDrawings, 0);
    };
    Person.prototype.getRequiredDrawingsUnder60 = function (targetIncome, otherIncome, agePension, indexedPension, paygTaxBasis, lowPossibleDrawingLevel, highPossibleDrawingLevel, recursionDepth) {
        if (recursionDepth === void 0) { recursionDepth = 0; }
        var foundRequiredDrawings;
        var netIncomeGivenLowPossibleDrawings;
        var netIncomeGivenHighPossibleDrawings;
        var interpolatedDrawings;
        var netIncomeGivenInterpolatedDrawings;
        var differenceBetweenLowerAndInterpolatedDrawings;
        var differenceBetweenInterpolatedAndUpperDrawings;
        var lowerDrawingsToRecurse;
        var upperDrawingsToRecurse;
        var taxOnInterpolatedDrawings;
        var pensionRebateOnInterpolatedDrawings;
        foundRequiredDrawings = false;
        netIncomeGivenLowPossibleDrawings = otherIncome
            + agePension
            + indexedPension
            + lowPossibleDrawingLevel
            - paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, agePension + lowPossibleDrawingLevel) + lowPossibleDrawingLevel * Constants.PENSION_REBATE_RATE;
        netIncomeGivenHighPossibleDrawings = otherIncome
            + agePension
            + indexedPension
            + highPossibleDrawingLevel
            - paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, agePension + highPossibleDrawingLevel) + highPossibleDrawingLevel * Constants.PENSION_REBATE_RATE;
        interpolatedDrawings = lowPossibleDrawingLevel +
            ((highPossibleDrawingLevel - lowPossibleDrawingLevel) *
                (targetIncome - netIncomeGivenLowPossibleDrawings) /
                (netIncomeGivenHighPossibleDrawings - netIncomeGivenLowPossibleDrawings));
        taxOnInterpolatedDrawings = paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, agePension + interpolatedDrawings);
        pensionRebateOnInterpolatedDrawings = interpolatedDrawings * Constants.PENSION_REBATE_RATE;
        pensionRebateOnInterpolatedDrawings = Math.min(taxOnInterpolatedDrawings, pensionRebateOnInterpolatedDrawings);
        netIncomeGivenInterpolatedDrawings = otherIncome + agePension + indexedPension + interpolatedDrawings -
            taxOnInterpolatedDrawings + pensionRebateOnInterpolatedDrawings;
        if ((Math.abs(netIncomeGivenInterpolatedDrawings - targetIncome) < DRAWINGS_SEARCH_TOLERANCE
            || recursionDepth >= DRAWINGS_MAX_SEARCH_DEPTH)) {
            foundRequiredDrawings = true;
        }
        if (foundRequiredDrawings) {
            return interpolatedDrawings;
        }
        else {
            differenceBetweenLowerAndInterpolatedDrawings = interpolatedDrawings - lowPossibleDrawingLevel;
            differenceBetweenInterpolatedAndUpperDrawings = highPossibleDrawingLevel - interpolatedDrawings;
            if (differenceBetweenLowerAndInterpolatedDrawings < differenceBetweenInterpolatedAndUpperDrawings) {
                lowerDrawingsToRecurse = lowPossibleDrawingLevel;
                upperDrawingsToRecurse = interpolatedDrawings;
            }
            else {
                lowerDrawingsToRecurse = interpolatedDrawings;
                upperDrawingsToRecurse = highPossibleDrawingLevel;
            }
            return this.getRequiredDrawingsUnder60(targetIncome, otherIncome, agePension, indexedPension, paygTaxBasis, lowerDrawingsToRecurse, upperDrawingsToRecurse, recursionDepth + 1);
        }
    };
    Person.prototype.optimiseTTR = function (minimumContributionsToTest, maximumContributionsToTest, maximumTTRDrawings, preTaxMemberContributions, employerContributions, paygIncomeTaxBasis, recursionDepth) {
        if (recursionDepth === void 0) { recursionDepth = 0; }
        var ttrContributions = ArrayUtils_1.InitialiseArray(11);
        var ttrDrawings = ArrayUtils_1.InitialiseArray(11);
        var ttrNetBenefit = ArrayUtils_1.InitialiseArray(11);
        var netIncomeBeforeTTR;
        var taxBeforeTTR;
        var taxGivenDrawings;
        var netIncomeAfterTTRContributions;
        var contributionsCounter;
        var foundOptimisedTTR;
        var noOptimalTTR;
        var maxBenefit;
        var maxConcessionalContributions;
        var indexOptimumContributionLevel;
        var indexClosestToOptimum;
        var lowerContributionLevelToRecurse;
        var upperContributionLevelToRecurse;
        foundOptimisedTTR = false;
        noOptimalTTR = false;
        maxBenefit = 0;
        indexOptimumContributionLevel = 0;
        taxBeforeTTR = paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload) + this.agePensionIncome - preTaxMemberContributions + this._OtherIncome.value);
        netIncomeBeforeTTR = (this._midYearSalary * this.workload) + this.agePensionIncome -
            preTaxMemberContributions + this._OtherIncome.value - taxBeforeTTR;
        if (this._memberType !== MemberType_1.MemberType.SUPERSA_SSS) {
            maxConcessionalContributions = this.concessionalContributionThreshold();
            if (maximumContributionsToTest > (maxConcessionalContributions - preTaxMemberContributions - employerContributions)) {
                maximumContributionsToTest = Math.max(0, maxConcessionalContributions - preTaxMemberContributions - employerContributions);
            }
            if (this.debugMode) {
                console.log("ALL -> Running optimiseTTR normal code");
                console.info("maxConcessionalContributions =", maxConcessionalContributions, "maximumContributionsToTest =", maximumContributionsToTest);
            }
        }
        for (contributionsCounter = 1; contributionsCounter <= 11; contributionsCounter++) {
            ttrContributions[contributionsCounter - 1] = Math.floor(minimumContributionsToTest +
                ((maximumContributionsToTest - minimumContributionsToTest) * ((contributionsCounter - 1) / 10)));
        }
        for (contributionsCounter = 1; contributionsCounter <= 11; contributionsCounter++) {
            if (this._age >= 60) {
                taxGivenDrawings = paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload)
                    + this.agePensionIncome
                    - preTaxMemberContributions
                    - ttrContributions[contributionsCounter - 1]
                    + this._OtherIncome.value);
                netIncomeAfterTTRContributions = (this._midYearSalary * this.workload) + this.agePensionIncome -
                    ttrContributions[contributionsCounter - 1] + this._OtherIncome.value - preTaxMemberContributions -
                    taxGivenDrawings;
                ttrDrawings[contributionsCounter - 1] = netIncomeBeforeTTR - netIncomeAfterTTRContributions;
            }
            else {
                if (ttrContributions[contributionsCounter - 1] === 0) {
                    ttrDrawings[contributionsCounter - 1] = 0;
                }
                else {
                    ttrDrawings[contributionsCounter - 1] = Math.floor(this.getTTRDrawingsForContributionLevelBelow60(netIncomeBeforeTTR, ttrContributions[contributionsCounter - 1], 0, ttrContributions[contributionsCounter - 1], paygIncomeTaxBasis));
                }
            }
            if (ttrDrawings[contributionsCounter - 1] > maximumTTRDrawings) {
                ttrNetBenefit[contributionsCounter - 1] = 0;
            }
            else {
                ttrNetBenefit[contributionsCounter - 1] =
                    this.ttrBenefit(ttrContributions[contributionsCounter - 1], preTaxMemberContributions + employerContributions, ttrDrawings[contributionsCounter - 1]);
            }
            if (ttrNetBenefit[contributionsCounter - 1] > maxBenefit + 1) {
                maxBenefit = ttrNetBenefit[contributionsCounter - 1];
                indexOptimumContributionLevel = contributionsCounter;
            }
        }
        if (indexOptimumContributionLevel === 1 || indexOptimumContributionLevel === 11) {
            foundOptimisedTTR = true;
        }
        else if (indexOptimumContributionLevel === 0 || recursionDepth >= TTR_MAX_SEARCH_DEPTH) {
            noOptimalTTR = true;
        }
        else {
            if (ttrNetBenefit[indexOptimumContributionLevel - 2] > ttrNetBenefit[indexOptimumContributionLevel]) {
                indexClosestToOptimum = indexOptimumContributionLevel - 1;
            }
            else {
                indexClosestToOptimum = indexOptimumContributionLevel + 1;
            }
            if ((ttrNetBenefit[indexOptimumContributionLevel - 1] - ttrNetBenefit[indexClosestToOptimum - 1]) < TTR_SEARCH_TOLERANCE) {
                foundOptimisedTTR = true;
            }
        }
        if (foundOptimisedTTR) {
            this._ttrContributions = ttrContributions[indexOptimumContributionLevel - 1];
            this._ttrDrawings = ttrDrawings[indexOptimumContributionLevel - 1];
            this._ttrContributionsHistory[this._arrayCounter] = this._ttrContributions;
            this._ttrDrawingsHistory[this._arrayCounter] = this._ttrDrawings;
            this._ttrTaxBenefitHistory[this._arrayCounter] = ttrNetBenefit[indexOptimumContributionLevel - 1];
            var TaxOnSalaryAfterContributions = void 0;
            TaxOnSalaryAfterContributions = paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload) +
                this.agePensionIncome -
                preTaxMemberContributions -
                ttrContributions[indexOptimumContributionLevel - 1] +
                this._OtherIncome.value);
            this._ttrIncomeReductionHistory[this._arrayCounter] = ttrContributions[indexOptimumContributionLevel - 1] + TaxOnSalaryAfterContributions - taxBeforeTTR;
        }
        else if (noOptimalTTR) {
            this._ttrContributions = 0;
            this._ttrDrawings = 0;
            this._ttrContributionsHistory[this._arrayCounter] = this._ttrContributions;
            this._ttrDrawingsHistory[this._arrayCounter] = this._ttrDrawings;
        }
        else {
            lowerContributionLevelToRecurse = ttrContributions[indexOptimumContributionLevel - 2];
            upperContributionLevelToRecurse = ttrContributions[indexOptimumContributionLevel];
            this.optimiseTTR(lowerContributionLevelToRecurse, upperContributionLevelToRecurse, maximumTTRDrawings, preTaxMemberContributions, employerContributions, paygIncomeTaxBasis, recursionDepth + 1);
        }
    };
    Person.prototype.getTTRDrawingsForContributionLevelBelow60 = function (netIncomeToMatch, ttrContributions, lowPossibleDrawingLevel, highPossibleDrawingLevel, paygTaxBasis, recursionDepth) {
        if (recursionDepth === void 0) { recursionDepth = 0; }
        var foundRequiredDrawings = false;
        var netIncomeGivenLowPossibleDrawings = 0;
        var netIncomeGivenHighPossibleDrawings = 0;
        var interpolatedDrawings = 0;
        var netIncomeGivenInterpolatedDrawings = 0;
        var differenceBetweenLowerAndInterpolatedDrawings = 0;
        var differenceBetweenInterpolatedAndUpperDrawings = 0;
        var lowerDrawingsToRecurse = 0;
        var upperDrawingsToRecurse = 0;
        netIncomeGivenLowPossibleDrawings = (this._midYearSalary * this.workload)
            + this.agePensionIncome
            - ttrContributions
            + this._OtherIncome.value
            + lowPossibleDrawingLevel
            - this.preTaxMemberContributions
            - paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload)
                + this.agePensionIncome
                - ttrContributions
                - this.preTaxMemberContributions
                + this._OtherIncome.value
                + lowPossibleDrawingLevel) + lowPossibleDrawingLevel * Constants.PENSION_REBATE_RATE;
        netIncomeGivenHighPossibleDrawings = (this._midYearSalary * this.workload)
            + this.agePensionIncome
            - ttrContributions
            + this._OtherIncome.value
            + highPossibleDrawingLevel
            - this.preTaxMemberContributions
            - paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload)
                + this.agePensionIncome
                - ttrContributions
                - this.preTaxMemberContributions
                + this._OtherIncome.value
                + highPossibleDrawingLevel) + highPossibleDrawingLevel * Constants.PENSION_REBATE_RATE;
        interpolatedDrawings = lowPossibleDrawingLevel +
            ((highPossibleDrawingLevel - lowPossibleDrawingLevel) *
                (netIncomeToMatch - netIncomeGivenLowPossibleDrawings) /
                (netIncomeGivenHighPossibleDrawings - netIncomeGivenLowPossibleDrawings));
        netIncomeGivenInterpolatedDrawings = (this._midYearSalary * this.workload)
            + this.agePensionIncome
            - ttrContributions
            + this._OtherIncome.value
            + interpolatedDrawings
            - this.preTaxMemberContributions
            - paygTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, (this._midYearSalary * this.workload)
                + this.agePensionIncome
                - ttrContributions
                - this.preTaxMemberContributions
                + this._OtherIncome.value
                + interpolatedDrawings) + interpolatedDrawings * Constants.PENSION_REBATE_RATE;
        if ((Math.abs(netIncomeGivenInterpolatedDrawings - netIncomeToMatch) < TTR_DRAWINGS_SEARCH_TOLERANCE
            || recursionDepth >= TTR_DRAWINGS_MAX_SEARCH_DEPTH)) {
            foundRequiredDrawings = true;
        }
        if (foundRequiredDrawings) {
            return interpolatedDrawings;
        }
        else {
            differenceBetweenLowerAndInterpolatedDrawings = interpolatedDrawings - lowPossibleDrawingLevel;
            differenceBetweenInterpolatedAndUpperDrawings = highPossibleDrawingLevel - interpolatedDrawings;
            if (differenceBetweenLowerAndInterpolatedDrawings < differenceBetweenInterpolatedAndUpperDrawings) {
                lowerDrawingsToRecurse = lowPossibleDrawingLevel;
                upperDrawingsToRecurse = interpolatedDrawings;
            }
            else {
                lowerDrawingsToRecurse = interpolatedDrawings;
                upperDrawingsToRecurse = highPossibleDrawingLevel;
            }
            return this.getTTRDrawingsForContributionLevelBelow60(netIncomeToMatch, ttrContributions, lowerDrawingsToRecurse, upperDrawingsToRecurse, paygTaxBasis, recursionDepth + 1);
        }
    };
    Person.prototype.ttrBenefit = function (ttrContributions, otherConcessionalContributions, ttrDrawings) {
        var netTotalConcessionalContributions;
        var netOtherConcessionalContributions;
        var netTTRContributions;
        netTotalConcessionalContributions =
            this.netConcessionalContributions(ttrContributions + otherConcessionalContributions);
        netOtherConcessionalContributions =
            this.netConcessionalContributions(otherConcessionalContributions);
        netTTRContributions =
            netTotalConcessionalContributions - netOtherConcessionalContributions;
        return netTTRContributions - ttrDrawings;
    };
    Person.prototype.netConcessionalContributions = function (concessionalContributions) {
        var salaryInYear = this._midYearSalary * this.workload;
        var concessionalContributionThreshold;
        var tax;
        concessionalContributionThreshold = this._concessionalContributionThreshold.value;
        concessionalContributionThreshold = Math.floor(concessionalContributionThreshold / 2500) * 2500;
        if (this.memberType === MemberType_1.MemberType.SUPERSA_SSS) {
            if ((salaryInYear + concessionalContributions) < this._highIncomeEarningThreshold.value) {
                tax = 0;
            }
            else if (salaryInYear > this._highIncomeEarningThreshold.value) {
                tax = concessionalContributions * Constants.SUPERANNUATION_TAX_RATE;
            }
            else {
                tax = (salaryInYear + concessionalContributions - this._highIncomeEarningThreshold.value) * Constants.SUPERANNUATION_TAX_RATE;
            }
            if (this.debugMode) {
                console.log("SUPERSA_SSS -> Running netConcessionalContributions() SuperSA.SSS specific code");
                console.info("tax =", tax);
            }
        }
        else {
            if ((salaryInYear + concessionalContributions) < this._highIncomeEarningThreshold.value) {
                tax = concessionalContributions * Constants.SUPERANNUATION_TAX_RATE;
            }
            else if (salaryInYear > this._highIncomeEarningThreshold.value) {
                tax = concessionalContributions * Constants.SUPERANNUATION_TAX_RATE_HIGH_EARNER;
            }
            else {
                tax = ((this._highIncomeEarningThreshold.value - salaryInYear) * Constants.SUPERANNUATION_TAX_RATE) +
                    ((salaryInYear + concessionalContributions - this._highIncomeEarningThreshold.value) * Constants.SUPERANNUATION_TAX_RATE_HIGH_EARNER);
            }
            if (this.debugMode) {
                console.log("ALL -> Running netConcessionalContributions() normal code");
                console.info("tax =", tax);
            }
        }
        if (salaryInYear < this._lowIncomeEarnersGovernmentContributionIncomeThreshold.value) {
            tax = Math.max(0, tax - this._lowIncomeEarnersGovernmentContributionMaximum.value);
        }
        return concessionalContributions - tax;
    };
    Person.prototype.concessionalContributionThreshold = function () {
        return Math.floor(this._concessionalContributionThreshold.value / 2500) * 2500;
        ;
    };
    Person.prototype.deflate = function (wageInflation, priceInflation, memberType, startAge, retirementAge) {
        var wageDeflationFactor = 1;
        var artDeflationFactor = 1;
        var discountRateInYear = 0;
        var deflationFactor = 1;
        var age = startAge + 1;
        this._deflatedSalary[0] = this._annualFullTimeSalaryHistory[0] * this._workDaysPerWeek[0] / Constants.FULL_TIME_DAYS_PER_WEEK;
        this._deflatedNetSalary[0] = this._deflatedSalary[0] - this._incomeTaxHistory[0];
        this._deflatedTargetIncome[0] = this._targetIncomeHistory[0];
        this._deflatedOtherIncome[0] = this._OtherIncomeHistory[0];
        this._deflatedAgePension[0] = this._agePensionHistory[0];
        this._deflatedRetirementIncomeProductIncomeHistory[0] = this._retirementIncomeProductIncomeHistory[0];
        this._deflatedIndexedPension[0] = this._indexedPensionHistory[0];
        this._deflatedPreTaxMemberContribution[0] = this._preTaxMemberContributionHistory[0];
        this._deflatedPostTaxMemberContribution[0] = this._postTaxMemberContributionHistory[0];
        for (var i = 2; i <= this._annualFullTimeSalaryHistory.length; i++) {
            if ((age > retirementAge) && (this._discountWithPriceInflationInRetirement === true)) {
                discountRateInYear = priceInflation.getIndexationRate(i - 1);
            }
            else {
                discountRateInYear = wageInflation.getIndexationRate(i - 1);
            }
            if (((memberType === MemberType_1.MemberType.ESSS_AssistMe_DB) ||
                (memberType === MemberType_1.MemberType.ESSS_AssistMe)) && (i === 2)) {
                deflationFactor = Math.pow((deflationFactor / (1 + discountRateInYear)), this._LengthOfPeriodInFirstProjectionPeriod);
            }
            else {
                deflationFactor = deflationFactor / (1 + discountRateInYear);
            }
            this._deflatedTargetIncome[i - 1] = this._targetIncomeHistory[i - 1] * deflationFactor;
            this._deflatedOtherIncome[i - 1] = this._OtherIncomeHistory[i - 1] * deflationFactor;
            this._deflatedAgePension[i - 1] = this._agePensionHistory[i - 1] * deflationFactor;
            this._deflatedRetirementIncomeProductIncomeHistory[i - 1] = this._retirementIncomeProductIncomeHistory[i - 1] * deflationFactor;
            this._deflatedSalary[i - 1] = this._annualFullTimeSalaryHistory[i - 1] * this._workDaysPerWeek[i - 1] / Constants.FULL_TIME_DAYS_PER_WEEK * deflationFactor;
            this._deflatedNetSalary[i - 1] = this._deflatedSalary[i - 1] - (this._incomeTaxHistory[i - 1] * deflationFactor);
            age++;
        }
    };
    Object.defineProperty(Person.prototype, "isRetired", {
        get: function () {
            if (this._phase === PhaseType_1.PhaseType.RETIRED) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "inTTR", {
        get: function () {
            if (this._phase === PhaseType_1.PhaseType.TTR) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "accumulationOnly", {
        get: function () {
            if (this._phase === PhaseType_1.PhaseType.ACCUMULATION) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "lumpSumContribution", {
        get: function () {
            return this._lumpSumMemberContributions[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_lumpSumContribution = function () {
        return this._lumpSumMemberContributions[this._arrayCounter];
    };
    Object.defineProperty(Person.prototype, "downsizerContribution", {
        get: function () {
            return this._DownsizerContributions[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_downsizerContribution = function () {
        return this._DownsizerContributions[this._arrayCounter];
    };
    Person.prototype.rollOver = function () {
        if (this._arrayCounter + 1 >= this._rollOver.length) {
            return 0;
        }
        else {
            return this._rollOver[this._arrayCounter + 1];
        }
    };
    Object.defineProperty(Person.prototype, "immediateRollOverInFirstYear", {
        get: function () {
            return this._rollOver[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "agePensionIncome", {
        get: function () {
            return this._agePensionHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_immediateRollOverInFirstYear = function () {
        return this._rollOver[0];
    };
    Person.prototype.get_agePensionIncome = function () {
        return this._agePensionHistory[this._arrayCounter];
    };
    Person.prototype.setAgePensionInYear = function (agePension) {
        this._agePensionHistory[this._arrayCounter] = agePension;
    };
    Person.prototype.getAgePensionInYear = function (yearCount) {
        return this._agePensionHistory[yearCount - 1];
    };
    Object.defineProperty(Person.prototype, "indexedPensionIncome", {
        get: function () {
            return this._indexedPensionHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_indexedPensionIncome = function () {
        return this._indexedPensionHistory[this._arrayCounter];
    };
    Person.prototype.setIndexedPensionInYear = function (agePension) {
        this._indexedPensionHistory[this._arrayCounter] = agePension;
    };
    Person.prototype.getIndexedPensionInYear = function (yearCount) {
        return this._indexedPensionHistory[yearCount - 1];
    };
    Person.prototype.getSalaryInYear = function (yearCount) {
        return this._annualFullTimeSalaryHistory[yearCount - 1];
    };
    Person.prototype.getMidYearSalaryInYear = function (yearCount) {
        return this._annualFullTimeMidYearSalaryHistory[yearCount - 1];
    };
    Person.prototype.setTTRDrawingsInYear = function (ttrDrawings) {
        this._ttrDrawingsHistory[this._arrayCounter] = ttrDrawings;
    };
    Person.prototype.getTTRDrawingsInYear = function (yearCount) {
        return this._ttrDrawingsHistory[yearCount - 1];
    };
    Person.prototype.setTTRContributionsInYear = function (ttrContributions) {
        this._ttrContributionsHistory[this._arrayCounter] = ttrContributions;
    };
    Person.prototype.getTTRContributionsInYear = function (yearCount) {
        return this._ttrContributionsHistory[yearCount - 1];
    };
    Person.prototype.setTTRIncomeReductionInYear = function (ttrIncomeReduction) {
        this._ttrIncomeReductionHistory[this._arrayCounter] = ttrIncomeReduction;
    };
    Person.prototype.getTTRIncomeReductionInYear = function (yearCount) {
        return this._ttrIncomeReductionHistory[yearCount - 1];
    };
    Person.prototype.setTTRTaxBenefitInYear = function (ttrTaxBenefit) {
        this._ttrTaxBenefitHistory[this._arrayCounter] = ttrTaxBenefit;
    };
    Person.prototype.getTTRTaxBenefitInYear = function (yearCount) {
        return this._ttrTaxBenefitHistory[yearCount - 1];
    };
    Person.prototype.setTTRPostContributionNetSalaryInYear = function (ttrPostContributionNetSalary) {
        this._ttrPostContributionNetSalaryHistory[this._arrayCounter] = ttrPostContributionNetSalary;
    };
    Person.prototype.getTTRPostContributionNetSalaryInYear = function (yearCount) {
        return this._ttrPostContributionNetSalaryHistory[yearCount - 1];
    };
    Person.prototype.setTTRProblemCanNotTopUpSalaryInYear = function (ttrProblemCanNotTopUpSalary) {
        this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter] = ttrProblemCanNotTopUpSalary;
    };
    Person.prototype.getTTRProblemCanNotTopUpSalaryInYear = function (yearCount) {
        return this._ttrProblemCanNotTopUpSalaryHistory[yearCount - 1];
    };
    Person.prototype.getWorkLoadInYear = function (yearCount) {
        return this._workDaysPerWeek[yearCount - 1];
    };
    Person.prototype.getFinancialAssets = function () {
        return this._FinancialAssets;
    };
    Person.prototype.getIncomeWithNoBackingAssets = function () {
        return this._IncomeWithNoBackingAssets;
    };
    Person.prototype.getIncomeWithNoBackingAssets_CeaseAge = function () {
        return this._IncomeWithNoBackingAssets_CeaseAge;
    };
    Object.defineProperty(Person.prototype, "sex", {
        get: function () {
            return this._sex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "salary", {
        get: function () {
            return this._annualFullTimeSalary.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "midYearSalary", {
        get: function () {
            return this._midYearSalary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "workload", {
        get: function () {
            return this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "age", {
        get: function () {
            return this._age;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ageRetirementIncomeProductCommences", {
        get: function () {
            return this._RetirementIncomeProduct_AgeIncomeStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ageCeaseCurrentEmployment", {
        get: function () {
            return this._ageCeaseCurrentEmployment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "FinancialAssets", {
        get: function () {
            var TotalFinancialAssets = 0;
            for (var counter = 1; counter < this._FinancialAssets.length; counter++) {
                TotalFinancialAssets += this._FinancialAssets[counter].value;
            }
            return TotalFinancialAssets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "IncomeOnFinancialAssets", {
        get: function () {
            var TotalIncomeOnFinancialAssets = 0;
            for (var counter = 1; counter < this._IncomeOnFinancialAssets.length; counter++) {
                TotalIncomeOnFinancialAssets += this._IncomeOnFinancialAssets[counter].value;
            }
            return TotalIncomeOnFinancialAssets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "NonFinancialAssets", {
        get: function () {
            return this._NonFinancialAssets.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "IncomeOnNonFinancialAssets", {
        get: function () {
            return this._IncomeOnNonFinancialAssets.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "IncomeWithNoBackingAssets", {
        get: function () {
            var TotalIncomeWithNoBackingAssets = 0;
            for (var counter = 1; counter < this._IncomeWithNoBackingAssets.length; counter++) {
                TotalIncomeWithNoBackingAssets += this._IncomeWithNoBackingAssets[counter].value;
            }
            return TotalIncomeWithNoBackingAssets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "PersonalAssets", {
        get: function () {
            return this._PersonalAssets.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "otherIncome", {
        get: function () {
            return this._OtherIncome.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "retirementProductIncome", {
        get: function () {
            return this._RetirementIncomeProduct_Income.value;
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_sex = function () {
        return this._sex;
    };
    Person.prototype.get_salary = function () {
        return this._annualFullTimeSalary.value;
    };
    Person.prototype.get_midYearSalary = function () {
        return this._midYearSalary;
    };
    Person.prototype.get_workload = function () {
        return this._workDaysPerWeek[this._arrayCounter] / Constants.FULL_TIME_DAYS_PER_WEEK;
    };
    Person.prototype.get_otherIncome = function () {
        return this._OtherIncome.value;
    };
    Person.prototype.getOtherIncomeInYear = function (yearCount) {
        return this._OtherIncomeHistory[yearCount - 1];
    };
    Person.prototype.getRetirementIncomeProductIncomeInYear = function (yearCount) {
        return this._retirementIncomeProductIncomeHistory[yearCount - 1];
    };
    Person.prototype.getTargetIncomeInYear = function (yearCount) {
        return this._targetIncomeHistory[yearCount - 1];
    };
    Object.defineProperty(Person.prototype, "dateBirth", {
        get: function () {
            return this._dateBirth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "isHomeOwner", {
        get: function () {
            return this._isHomeOwner;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "isMarried", {
        get: function () {
            return this._isMarried;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "phase", {
        get: function () {
            return this._phase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrContributions", {
        get: function () {
            return this._ttrContributions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrDrawings", {
        get: function () {
            return this._ttrDrawings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrIncomeReduction", {
        get: function () {
            return this._ttrIncomeReductionHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrTaxBenefit", {
        get: function () {
            return this._ttrTaxBenefitHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrPostContributionNetSalary", {
        get: function () {
            return this._ttrPostContributionNetSalaryHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "ttrProblemCanNotTopUpSalary", {
        get: function () {
            return this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "preTaxMemberContributions", {
        get: function () {
            return this._preTaxMemberContributionHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "postTaxMemberContributions", {
        get: function () {
            return this._postTaxMemberContributionHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "targetIncome", {
        get: function () {
            return this._targetIncome.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "startAge", {
        get: function () {
            return this._startAge;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "retirementAge", {
        get: function () {
            return this._retirementAge;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_AgeOfPurchase", {
        get: function () {
            return this._RetirementIncomeProduct_AgeOfPurchase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_AgeIncomeStart", {
        get: function () {
            return this._RetirementIncomeProduct_AgeIncomeStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_PurchaseProportion", {
        get: function () {
            return this._RetirementIncomeProduct_PurchaseProportion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_IncomePer100KPurchase", {
        get: function () {
            return this._RetirementIncomeProduct_IncomePer100KPurchase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_UseDefaultIncomePer100KPurchase", {
        get: function () {
            return this._RetirementIncomeProduct_UseDefaultIncomePer100KPurchase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "IsARetirementIncomeProduct", {
        get: function () {
            return this._IsARetirementIncomeProduct;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_ElectionBasedOnAssetsToConvert", {
        get: function () {
            return this._RetirementIncomeProduct_ElectionBasedOnAssetsToConvert;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert", {
        get: function () {
            return this._RetirementIncomeProduct_ElectionBasedOnDollarsOfAssetsToConvert;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_PurchaseBalance", {
        get: function () {
            return this._RetirementIncomeProduct_PurchaseAssetBalance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_AimAnnualIncome", {
        get: function () {
            return this._RetirementIncomeProduct_AimAnnualIncome;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_PurchaseBalance_FutureDollars", {
        get: function () {
            return this._RetirementIncomeProduct_PurchaseAssetBalance_FutureDollars;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "RetirementIncomeProduct_AimAnnualIncome_FutureDollars", {
        get: function () {
            return this._RetirementIncomeProduct_AimAnnualIncome_FutureDollars;
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_dateBirth = function () {
        return this._dateBirth;
    };
    Person.prototype.get_isHomeOwner = function () {
        return this._isHomeOwner;
    };
    Person.prototype.get_isMarried = function () {
        return this._isMarried;
    };
    Person.prototype.get_phase = function () {
        return this._phase;
    };
    Person.prototype.get_ttrContributions = function () {
        return this._ttrContributions;
    };
    Person.prototype.get_ttrDrawings = function () {
        return this._ttrDrawings;
    };
    Person.prototype.get_ttrIncomeReductionHistory = function () {
        return this._ttrIncomeReductionHistory[this._arrayCounter];
    };
    Person.prototype.get_ttrTaxBenefitHistory = function () {
        return this._ttrTaxBenefitHistory[this._arrayCounter];
    };
    Person.prototype.get_ttrPostContributionNetSalaryHistory = function () {
        return this._ttrPostContributionNetSalaryHistory[this._arrayCounter];
    };
    Person.prototype.get_ttrProblemCanNotTopUpSalaryHistory = function () {
        return this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter];
    };
    Person.prototype.get_preTaxMemberContributions = function () {
        return this._preTaxMemberContributionHistory[this._arrayCounter];
    };
    Person.prototype.get_postTaxMemberContributions = function () {
        return this._postTaxMemberContributionHistory[this._arrayCounter];
    };
    Person.prototype.get_targetIncome = function () {
        return this._targetIncome.value;
    };
    Person.prototype.get_startAge = function () {
        return this._startAge;
    };
    Person.prototype.get_retirementAge = function () {
        return this._retirementAge;
    };
    Person.prototype.getDeflatedSalaryInYear = function (year) {
        return this._deflatedSalary[year - 1];
    };
    Person.prototype.getDeflatedPreTaxContributionsInYear = function (year) {
        return this._deflatedPreTaxMemberContribution[year - 1];
    };
    Person.prototype.getDeflatedPostTaxContributionsInYear = function (year) {
        return this._deflatedPostTaxMemberContribution[year - 1];
    };
    Person.prototype.getDeflatedNetSalaryInYear = function (year) {
        return this._deflatedNetSalary[year - 1];
    };
    Person.prototype.getDeflatedOtherIncomeInYear = function (year) {
        return this._deflatedOtherIncome[year - 1];
    };
    Person.prototype.getDeflatedRetirementIncomeProductIncomeInYear = function (year) {
        return this._deflatedRetirementIncomeProductIncomeHistory[year - 1];
    };
    Person.prototype.getDeflatedTargetIncomeInYear = function (year) {
        return this._deflatedTargetIncome[year - 1];
    };
    Person.prototype.getDeflatedAgePensionInYear = function (year) {
        return this._deflatedAgePension[year - 1];
    };
    Person.prototype.getDeflatedIndexedPensionInYear = function (year) {
        return this._deflatedIndexedPension[year - 1];
    };
    Object.defineProperty(Person.prototype, "expectedAgeAtDeath", {
        get: function () {
            return this._expectedAgeAtDeath;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "lifeExpectancyAtRetirement", {
        get: function () {
            return this._lifeExpectancyAtRetirement;
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_expectedAgeAtDeath = function () {
        return this._expectedAgeAtDeath;
    };
    Person.prototype.get_lifeExpectancyAtRetirement = function () {
        return this._lifeExpectancyAtRetirement;
    };
    Person.prototype.get_sunSuperSurvival50Percent = function () {
        return this._sunSuperSurvival50Percent;
    };
    Person.prototype.get_sunSuperSurvival10Percent = function () {
        return this._sunSuperSurvival10Percent;
    };
    Person.prototype.setCoContributions = function (coContributions) {
        this._coContributions = coContributions;
    };
    Object.defineProperty(Person.prototype, "coContributions", {
        get: function () {
            return this._coContributions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "retiredThisYear", {
        get: function () {
            return this._retiredThisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "lumpSumWithdrawalAtRetirement", {
        get: function () {
            return this._lumpSumWithdrawalAtRetirement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "discountWithPriceInflationInRetirement", {
        get: function () {
            return this._discountWithPriceInflationInRetirement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "indexedLumpSumWithdrawalAtRetirement", {
        get: function () {
            return this._indexedLumpSumWithdrawalAtRetirement.value;
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_coContributions = function () {
        return this._coContributions;
    };
    Person.prototype.get_retiredThisYear = function () {
        return this._retiredThisYear;
    };
    Person.prototype.get_lumpSumWithdrawalAtRetirement = function () {
        return this._lumpSumWithdrawalAtRetirement;
    };
    Person.prototype.get_indexedLumpSumWithdrawalAtRetirement = function () {
        return this._indexedLumpSumWithdrawalAtRetirement.value;
    };
    Person.prototype.setRetirementDrawings = function (retirementDrawings) {
        this._retirementDrawingsHistory[this._arrayCounter] = retirementDrawings;
    };
    Object.defineProperty(Person.prototype, "retirementDrawings", {
        get: function () {
            return this._retirementDrawingsHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.get_retirementDrawings = function () {
        return this._retirementDrawingsHistory[this._arrayCounter];
    };
    Person.prototype.getDrawingsRequiredInRetirementInYear = function (year) {
        return this._retirementDrawingsHistory[year - 1];
    };
    Person.prototype.setTTRDrawingsOnlyModeDrawings = function (maximumTTRDrawings) {
        this._ttrDrawings = Math.min(this._TTRUserSpecifiedDrawings.value, maximumTTRDrawings);
        this._ttrDrawingsHistory[this._arrayCounter] = this._ttrDrawings;
        this._ttrContributions = 0;
        this._ttrContributionsHistory[this._arrayCounter] = this._ttrContributions;
        if (this._TTRUserSpecifiedDrawings.value > maximumTTRDrawings) {
            this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter] = true;
        }
        else {
            this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter] = false;
        }
    };
    Person.prototype.setTTRDrawingsToTopUpReducedSalary = function (maximumTTRDrawings, paygIncomeTaxBasis) {
        var CurrentGrossSalary;
        var ProposedGrossSalary;
        var CurrentNetSalary;
        var ProposedNetSalary;
        var ReductionInNetSalary;
        CurrentGrossSalary = this._annualFullTimeSalary.value;
        ProposedGrossSalary = CurrentGrossSalary * this._TTR_ProposedWorkLoad / this._TTR_CurrentWorkLoad;
        CurrentNetSalary = CurrentGrossSalary - paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, CurrentGrossSalary);
        ProposedNetSalary = ProposedGrossSalary - paygIncomeTaxBasis.taxPayable(this._sex, this._dateBirth, this._age, ProposedGrossSalary);
        ReductionInNetSalary = CurrentNetSalary - ProposedNetSalary;
        this._ttrDrawings = Math.min(ReductionInNetSalary, maximumTTRDrawings);
        this._ttrDrawingsHistory[this._arrayCounter] = this._ttrDrawings;
        this._ttrContributions = 0;
        this._ttrContributionsHistory[this._arrayCounter] = this._ttrContributions;
        this._ttrPostContributionNetSalaryHistory[this._arrayCounter] = ProposedNetSalary;
        if (ReductionInNetSalary > maximumTTRDrawings) {
            this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter] = true;
        }
        else {
            this._ttrProblemCanNotTopUpSalaryHistory[this._arrayCounter] = false;
        }
    };
    Person.prototype.setIncomeTax = function (incomeTax) {
        this._incomeTaxHistory[this._arrayCounter] = incomeTax;
    };
    Person.prototype.getIncomeTaxInYear = function (year) {
        return this._incomeTaxHistory[year - 1];
    };
    Person.prototype.setIndividualsTargetIncome = function (targetIncome) {
        this._individualsTargetIncomeHistory[this._arrayCounter] = targetIncome;
    };
    Person.prototype.getIndividualsTargetIncomeInYear = function (year) {
        return this._individualsTargetIncomeHistory[year - 1];
    };
    Object.defineProperty(Person.prototype, "accountType", {
        get: function () {
            return this._accountType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "memberType", {
        get: function () {
            return this._memberType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "TTRMode", {
        get: function () {
            return this._TTRMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "coreContributionsPostTax", {
        get: function () {
            return this._coreContributionsPostTax;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Person.prototype, "LengthOfPeriodInFirstProjectionPeriod", {
        get: function () {
            return this._LengthOfPeriodInFirstProjectionPeriod;
        },
        enumerable: true,
        configurable: true
    });
    Person.prototype.getLumpSumWithdrawalInYear = function (year) {
        if (((this.get_startAge() + year - 1) === this.get_retirementAge())) {
            return this._lumpSumWithdrawalAtRetirement;
        }
        else {
            return 0;
        }
    };
    Object.defineProperty(Person.prototype, "debugMode", {
        get: function () {
            return this._debugMode;
        },
        enumerable: true,
        configurable: true
    });
    return Person;
}());
exports.Person = Person;
//# sourceMappingURL=Person.js.map